var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-hero',_vm._b({attrs:{"src":require('@/assets/home-header.jpg'),"gradient":"to top, #419B911F, transparent"}},'base-hero',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }